@if (showTopBar())
{
    <div class="top-bar-container d-flex align-items-center justify-content-between">
        <h1 class="nunito-bold section-title">{{title() | translate}}</h1>

        <div class="d-flex align-items-center gap-3">
            @if (showClinicsDropdown())
            {
                <app-dropdown [control]="clinicControl" fieldName="ADMIN.INPUT_FIELDS.CLINIC" [options]="clinicOptions()" />
            }
            <button class="logged-profile-menu position-relative min-w-244" [class.active]="openMenuOptions()" [class.min-w-fit]="userName()?.length > 22">
                <div class="d-flex w-100 align-items-center gap-1 justify-content-between" (click)="menuOptionsTrigger()">
                    <div class="d-flex align-items-center gap-2">
                        <img [src]="picture()" class="profile-image">
                        <div class="d-flex flex-column">
                            @if (userName()?.length > 1)
                            {
                                <p class="nunito-semibold name">
                                    {{userName()}}
                                </p>
                            }
                            <p class="nunito-regular role">
                                {{userTypeLabel() | translate}}
                            </p>
                        </div>
                    </div>
                    <svg-icon src="assets/icons/chevron-down.svg" class="open-menu-icon d-flex align-items-center justify-content-center"/>
                </div>
                <div class="menu-options w-100 position-absolute d-flex flex-column gap-1" [ngClass]="isAdminOrClinician() ? 'fh-3' : 'fh-2'">
                    <hr>
                    <div role="button" class="menu-item-container d-flex align-items-center" [routerLink]="getDashboardLink()" routerLinkActive="active" (click)="openMenuOptions.set(false)">
                        <svg-icon src="assets/icons/profile.svg" />
                        <span class="nunito">{{'SIDEBAR.PROFILE' | translate}}</span>
                    </div>
                    @if (isAdminOrClinician())
                    {
                        <div role="button" class="menu-item-container d-flex align-items-center" (click)="changeProfile()">
                            <svg-icon [src]="changeProfileIcon()" />
                            <span class="nunito">
                                {{changeProfileLabel() | translate}}
                            </span>
                        </div>
                    }
                    <div role="button" class="menu-item-container logout d-flex align-items-center" (click)="logout()">
                        <svg-icon src="assets/icons/logout.svg" />
                        <span class="nunito">{{'SIDEBAR.LOGOUT' | translate}}</span>
                    </div>
                </div>
            </button>
            @if(isAdminOrClinician())
            {
                <app-notification-center />
            }
        </div>
    </div>
    @if (showFilters())
    {
        <div class="filter-area d-flex align-items-center justify-content-between">
            <app-search-input />
            @if (showInviteButton())
            {
                <app-button label="ADMIN.HEALTHCARE_PROFESSIONALS.INVITE" icon="add" [inverted]="true" [fullWidth]="false" (pressed)="buttonClicked()"/>
            }
            @if (showAddClinicButton())
            {
                <app-button label="ADMIN.CLINICS.ADD" icon="add" [fullWidth]="false" (pressed)="buttonClicked()"/>
            }
            @if (showAddCampaignButton())
            {
                <app-button label="OWNER.CAMPAIGNS.NEW_CAMPAIGN" icon="add" [inverted]="true" [fullWidth]="false" (pressed)="buttonClicked()"/>
            }
            @if (showAddSpecialityButton())
            {
                <app-button label="OWNER.SPECIALITIES.NEW_SPECIALITY" icon="add" [inverted]="true" [fullWidth]="false" (pressed)="buttonClicked()"/>
            }
        </div>
    }
}

